/*
 * @Author: hanhuixian hanhuixian@lxrental.com
 * @Date: 2023-08-21 14:37:26
 * @LastEditors: hanhuixian hanhuixian@lxrental.com
 * @LastEditTime: 2023-08-23 15:08:13
 * @Description: 数据埋点-基类方法
 * 注：每次新增、修改业务埋点数据时，需要对应更新维护钉钉文档信息：
 * https://alidocs.dingtalk.com/i/nodes/R1zknDm0WR3egaRzTrnPYyaXVBQEx5rG?utm_scene=team_space
 */
 /* eslint-disable */
const goRentUtil = {
    goRent:function(track_event, event, biz, properties) {
        try {
           _goRent({
                track_event: track_event,
                biz: biz,
                event: event,
                properties: properties,
            });
        } catch (e) {
            console.log(e);
        }
    },
    // 页面浏览量统计（此方法页面加载默认调用, 单页应用需要手动调用）
    pageView:function() {
        try {
            _goRent({
                track_event: 'PageView',
            });
        } catch (e) {
            console.log(e);
        }
    },
    // 设置埋点数据-登录用户ID（其他埋点方法如果没有传UID参数，会获取这个方法设置的uid）
    setUID:function(uid) {
        try {
            _goRentSetUID(uid);
        } catch (e) {
            console.log(e);
        }
    },
    /**
     * 页面内容点击统计
     * @param  {
     * event: 触发事件元素， 英文/中文均可
     * biz: 触发事件事件描述
     * properties: 相关统计自定义参数
     * } params
     *  */
    pageClick:function(params) {
        goRentUtil.goRent('WebClick', params.event, params.biz, params.properties);
    }
}


module.exports = {
    pageView: goRentUtil.pageView,
    setUID: goRentUtil.setUID,
    pageClick: goRentUtil.pageClick
}